import { FAQAccessInfo } from 'router/subrouters/DataRoom/models/FAQ';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';
import httpClient from '../../httpClient';

function createAnswer(
  questionId: string,
  values: {
    answerContent: string;
    autoApproveAnswer?: boolean;
    publishToFAQ?: boolean;
  } & Partial<FAQAccessInfo>,
) {
  return httpClient.post(
    `/data-room-questions/${questionId}/answer-question`,
    values,
  );
}

function editAnswer(questionId: string, answerContent?: string) {
  return httpClient.post(`/data-room-answers/${questionId}/edit-answer`, {
    answerContent,
  });
}

function approveAnswer(
  id: string,
  values: { publishToFAQ?: boolean } & FAQAccessInfo,
) {
  return httpClient.post(`/data-room-answers/${id}/approve-answer`, values);
}

function rejectAnswer(
  id: string,
  { rejectAnswerRespond }: { rejectAnswerRespond?: string },
) {
  return httpClient.post(`/data-room-answers/${id}/reject-answer`, {
    rejectAnswerRespond,
  });
}

function getDataRoomQuestionAnswererMembers(id: string) {
  return httpClient.get(
    `/data-room-members/data-rooms/${id}/question-answerers`,
  );
}

export type AnaliticsResponse = {
  totalNumberOfQuestions: number;
  totalPercentOfPublishedQuestions: number;
  totalAverageMinutesToPublish: number;
  graph: {
    min: number;
    max: number;
    data: Array<{
      key: string;
      value: number;
    }>;
  };
};

function getAnaliticsByStage(id: string) {
  return httpClient.get<AnaliticsResponse>(
    `data-room-question-reports/data-rooms/${id}/by-stage`,
  );
}

function getAnaliticsBySubject(id: string) {
  return httpClient.get<AnaliticsResponse>(
    `data-room-question-reports/data-rooms/${id}/by-subject`,
  );
}

function askAQuestionSell(
  dataRoomId: string,
  askSellQProps: Record<string, any>,
) {
  return httpClient.post<Question>(`data-room-questions/sell-side`, {
    dataRoomId,
    ...askSellQProps,
  });
}

export default {
  getAnaliticsByStage,
  getAnaliticsBySubject,
  createAnswer,
  editAnswer,
  approveAnswer,
  rejectAnswer,
  getDataRoomQuestionAnswererMembers,
  askAQuestionSell,
};
